export default {
  getCodeInvalid(state) {
    return state.codeInvalid;
  },
  getCodeValid(state) {
    return state.codeValid;
  },
};
